import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-h5" }

export function render(_ctx, _cache) {
  const _component_v_btn = _resolveComponent("v-btn")
  const _component_v_card_title = _resolveComponent("v-card-title")
  const _component_HtmlEditor = _resolveComponent("HtmlEditor")
  const _component_v_card_text = _resolveComponent("v-card-text")
  const _component_v_spacer = _resolveComponent("v-spacer")
  const _component_v_card_actions = _resolveComponent("v-card-actions")
  const _component_v_card = _resolveComponent("v-card")
  const _component_v_dialog = _resolveComponent("v-dialog")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.valueSync,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.valueSync) = $event)),
      "max-width": "60%"
    }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_btn, _mergeProps(props, { color: "primary" }), {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.buttonSignature), 1)
          ]),
          _: 1
        }, 16)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.header), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_HtmlEditor, {
                  content: _ctx.content,
                  "onUpdate:content": _cache[0] || (_cache[0] = $event => ((_ctx.content) = $event)),
                  identifier: "MainContent"
                }, null, 8, ["content"]),
                _createVNode(_component_HtmlEditor, {
                  content: _ctx.signature,
                  "onUpdate:content": _cache[1] || (_cache[1] = $event => ((_ctx.signature) = $event)),
                  identifier: "Signature"
                }, null, 8, ["content"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "green-darken-1",
                  variant: "text",
                  onClick: _ctx.saveContent
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" Save ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  color: "red-darken-1",
                  variant: "text",
                  onClick: _ctx.close
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" Close ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}